<div class="whole-container">
    <div class="top-section-container">
        <div class="top-section generic-container">
            <div class="title-back-btn-container">
                <mat-icon class="icon" (click)="goBack()"><mat-icon>arrow_back</mat-icon></mat-icon>
                <span class="title">Shopping Cart</span>
            </div>

            <div class="item-count-saving-container" *ngIf="products.length">
                <app-badge class="badge-discount">{{ cartItems.length }} items</app-badge>
                <span class="saving" *ngIf="totalMRP - totalAmount > 0"
                    >You're saving {{ "currency.rs" | translate }} {{ totalMRP - totalAmount }}</span
                >
            </div>
        </div>
    </div>

    <div class="bottom-section-container">
        <mat-spinner *ngIf="loading" class="loading-spinner" [diameter]="70"></mat-spinner>
        <div class="bottom-section generic-container" *ngIf="!loading && products.length; else emptyCart">
            <div class="items-section">
                @for (product of products; track $index) {
                <div class="item-container" [class.inactive]="!product.product.isActive">
                    <div class="image-container" (click)="clickImage(product.product.id)">
                        <img
                            class="image"
                            *ngIf="product.product.images; else placeholder"
                            [src]="product.product.images.imagesUrl[0]"
                            alt="Item Image"
                        />
                        <ng-template #placeholder>
                            <div class="image-placeholder"></div>
                        </ng-template>
                    </div>
                    <div class="item-detail-section">
                        <p class="item-name-button-container">
                            <span class="product-name"
                                >{{ product.product.name }}
                                <span
                                    *ngIf="product.product.modelQuantityJson && !product.product.model3DJson"
                                    class="model-count"
                                >
                                    ({{ product.product.modelQuantityJson.totalBlock }}
                                    {{ "productDetails.shape" | translate }})
                                </span>
                            </span>
                            <app-button variant="ghost" size="icon" (onClick)="onDeleteCartItem(product)">
                                <mat-icon class="delete-icon" fontSet="material-icons-outlined">delete</mat-icon>
                            </app-button>
                        </p>

                        <div
                            class="block-item-info-container"
                            *ngIf="product.product.category.includes(categories.BuyBlocks)"
                        >
                            <div class="node-hole-plane-config">
                                <div *ngIf="getFacesByType(product, 'Plane').length > 0" class="plane-config">
                                    <span class="block-face-label">{{ "cart.shapeFacetype.plane" | translate }}: </span>
                                    <span class="block-face-value">{{ getFacesByType(product, "Plane") }}</span>
                                </div>

                                <div *ngIf="getFacesByType(product, 'Hole').length > 0" class="hole-config">
                                    <span class="block-face-label">{{ "cart.shapeFacetype.hole" | translate }}: </span>
                                    <span class="block-face-value">{{ getFacesByType(product, "Hole") }}</span>
                                </div>

                                <div *ngIf="getFacesByType(product, 'Node').length > 0" class="node-config">
                                    <span class="block-face-label">{{ "cart.shapeFacetype.node" | translate }}: </span>
                                    <span class="block-face-value">{{ getFacesByType(product, "Node") }}</span>
                                </div>
                            </div>

                            <div class="color-config">
                                <div class="color-title-section">
                                    <p class="color-title">Color configuration</p>
                                </div>

                                <div class="color-info">
                                    <div *ngFor="let color of getFaceColors(product.singleBlockInfo?.color)">
                                        <div class="color-item">
                                            <div
                                                class="color-box"
                                                [ngStyle]="{ 'background-color': getColorValue(color.value) }"
                                            ></div>
                                            <div class="color-name">
                                                <span class="block-face-label">{{ color.key }} </span>
                                                <span class="block-face-value">
                                                    {{ color.value }}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <br />
                        </div>

                        <div class="quantity-and-price-content">
                            <div class="quantity-count" [class.disabled-quantity-input]="!product.product.isActive">
                                <span
                                    ><button
                                        class="decrement"
                                        (click)="onClick(-1, product.product.id, product.cartUUID!)"
                                        [disabled]="getProductQtyInCart(product.product.id, product.cartUUID!) <= 1"
                                    >
                                        -
                                    </button></span
                                >
                                <input
                                    type="number"
                                    class="quantity"
                                    [value]="getProductQtyInCart(product.product.id, product.cartUUID!)"
                                    (input)="onInputChange($event, product.product.id, product.cartUUID!)"
                                    (blur)="onBlur($event, product.product.id, product.cartUUID!)"
                                />
                                <span
                                    ><button
                                        class="increment"
                                        (click)="onClick(1, product.product.id, product.cartUUID!)"
                                        [disabled]="getProductQtyInCart(product.product.id, product.cartUUID!) >= 99"
                                    >
                                        +
                                    </button></span
                                >
                            </div>

                            <p class="item-price-section">
                                <span
                                    class="discount-price-section"
                                    *ngIf="product.product.discountedPrice; else noDiscount"
                                >
                                    <span class="discount-price"
                                        >{{ "currency.rs" | translate }}
                                        {{ product.product.discountedPrice | number: "1.0-2" }}
                                    </span>
                                    <span class="cut-price">
                                        {{ "currency.rs" | translate }}
                                        {{ product.product.price | number: "1.0-2" }} </span
                                    >&nbsp;
                                    <app-badge *ngIf="product.product.discountedPrice" class="badge-discount"
                                        >{{ product.product.discountPercentage }}%
                                        {{ "productOffer.off" | translate }}</app-badge
                                    >
                                </span>

                                <ng-template #noDiscount>
                                    <span class="price"
                                        >{{ "currency.rs" | translate }}
                                        {{ product.product.price | number: "1.0-2" }}</span
                                    >
                                </ng-template>
                            </p>
                        </div>

                        <div class="out-of-stock" *ngIf="!product.product.isActive">
                            {{ "cart.outOfStock" | translate }}
                        </div>
                    </div>
                </div>
                }
            </div>

            <div class="price-details-section">
                <p class="price-detail-heading">Order Summary</p>
                <p class="price-label-value">
                    <span class="label">Subtotal ({{ cartItems.length }} Items) </span>
                    <span class="value">{{ "currency.rs" | translate }} {{ totalMRP }}</span>
                </p>

                <p class="price-label-value">
                    <span class="label">{{ "checkout.shipping" | translate }}</span>
                    <span class="shipping-value">
                        <span *ngIf="deliveryCharge">{{ "currency.rs" | translate }}</span>
                        {{ deliveryCharge ? "+ " + ("currency.rs" | translate) + " " + deliveryCharge : "FREE" }}
                    </span>
                </p>

                <p class="saving-label-value">
                    <span class="saving-label">Your Savings</span>
                    <span class="saving-value">-{{ "currency.rs" | translate }} {{ totalMRP - totalAmount }}</span>
                </p>

                <div class="separator"></div>

                <p class="total-label-value">
                    <span class="total-label">Total</span>
                    <span class="total-value"
                        >{{ "currency.rs" | translate }} {{ totalMRP - totalDiscount - deliveryCharge }}</span
                    >
                </p>

                <div *ngIf="!isCheckoutEnabled" class="min-purchase-message">
                    {{ "cart.minOrderAmount" | translate }}
                </div>
                <app-button
                    variant="hero"
                    [disabled]="!isCheckoutEnabled"
                    buttonClass="explore-btn"
                    (onClick)="onCheckout()"
                >
                    {{ "Proceed to Checkout" }}
                </app-button>

                <app-button
                    variant="white"
                    buttonClass="explore-btn shadow-btn hover-bounce"
                    (onClick)="onNavigateToProductPage()"
                >
                    {{ "Continue Shopping" }}
                </app-button>

                <div class="separator"></div>

                <div class="payment-text-list">
                    <span class="dot dot--blue">
                        <mat-icon fontSet="material-icons-outlined" class="icon">lock</mat-icon>
                        Secure Payment
                    </span>
                    <span class="dot dot--red">
                        <mat-icon fontSet="material-icons-outlined" class="icon">local_shipping</mat-icon>
                        Fast Delivery
                    </span>
                    <span class="dot dot--green">
                        <mat-icon fontSet="material-icons-outlined" class="icon">autorenew</mat-icon>
                        Easy Returns
                    </span>
                </div>
            </div>
        </div>
        <ng-template #emptyCart>
            <div class="empty-cart-container">
                <div class="empty-cart" *ngIf="!loading && !products.length">
                    <div class="empty-image-container">
                        <mat-icon
                            svgIcon="emptyCart"
                            class="emptyCartIcon"
                            aria-hidden="false"
                            aria-label="Empty Cart"
                        />
                    </div>
                    <div class="message">
                        <div class="message-title">{{ "cart.emptyCart" | translate }}</div>
                        <div class="message-body">{{ "cart.cartMessage1" | translate }}</div>
                    </div>
                    <div class="button-container">
                        <app-button variant="hero" (onClick)="backToHome()">
                            {{ "cart.button.backToHomeBtn" | translate }}
                        </app-button>
                        <br />
                        <div class="button-info">{{ "cart.cartMessage2" | translate }}</div>
                    </div>
                </div>
            </div>
        </ng-template>
    </div>
</div>
